import NosaLogo, { NosaMark } from "@/components/NosaLogo";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { id: "beneficii", label: "Beneficii" },
  { id: "reteta", label: "Rețetă" },
  { id: "despre", label: "Despre" },
  { id: "povestea", label: "Povestea" },
  { id: "contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer className="border-t border-gold/10 bg-ink">
      <div className="mx-auto max-w-7xl px-6 py-14 lg:px-10 lg:py-16">
        <div className="flex flex-col items-start justify-between gap-10 lg:flex-row lg:items-center">
          <div>
            <NosaLogo />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-stone">
              Hrană umedă super premium pentru pisici, fabricată în România.
            </p>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`footer-link-${l.id}`}
                onClick={() => scrollToId(l.id)}
                className="font-mono text-[10px] uppercase tracking-[0.26em] text-stone transition-colors duration-300 hover:text-gold"
              >
                {l.label}
              </button>
            ))}
          </nav>
        </div>
        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-gold/10 pt-8 sm:flex-row sm:items-center">
          <p className="font-mono text-[9px] uppercase tracking-[0.24em] text-stone/60">
            © {new Date().getFullYear()} NOSA Pet Food · Toate drepturile rezervate
          </p>
          <p className="flex items-center gap-3 font-mono text-[9px] uppercase tracking-[0.24em] text-stone/60">
            <NosaMark className="h-5" />
            nosenpetfood.ro
          </p>
        </div>
      </div>
    </footer>
  );
}
